module.exports = __webpack_public_path__ + "static/media/frances-capa.19306bbe.png";